import { useState } from "react";
import { useDispatch } from "react-redux";
import { setMessage } from "../../redux";
import "./style.css";

function Reclam({ setReclam }) {
    const dispatch = useDispatch();
    const [form, setForm] = useState({
        subject: '',
        message: '',
        image: null,
    })

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.subject === '') {
            dispatch(setMessage('Merci de choisir le sujet de votre demande.'));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        if (form.message === '') {
            dispatch(setMessage('Merci de renseigner quelques mots dans "message".'));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        const token = sessionStorage.getItem("token");

        const formData = new FormData();
        formData.append("subject", form.subject);
        formData.append("message", form.message);

        if (form.image) {
            formData.append("image", form.image);
        }

        dispatch(setMessage('Chargement en cour, merci de patienter'));
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/contact`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        });
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            dispatch(setMessage(res.message));
            setTimeout(() => dispatch(setMessage()), 2000);
            return
        }

        setReclam(false);
        dispatch(setMessage('Votre message a bien été transmis, nous reviendrons vers vous si nécessaire.'));
        setTimeout(() => dispatch(setMessage()), 2000);
    };

    return (
        <div className="reclam">
            <div
                className="overlay"
                onClick={() => setReclam(false)}
            ></div>

            <form onSubmit={handleSubmit}>
                <button
                    type="button"
                    className="close_btn"
                    onClick={() => setReclam(false)}
                >✕</button>

                <h2>Contact annuaire PSOA</h2>

                <p className="text">
                    Un bug, une question ou une suggestion ? <br />
                    N'hésitez pas à nous en faire part ci-dessous :
                </p>

                <div className="inp_form">
                    <label>Objet</label>
                    <select
                        value={form.subject}
                        onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    >
                        <option value=''>Choisir un sujet</option>
                        <option value='Bug du site'>Bug</option>
                        <option value='Question utilisateur'>Question</option>
                        <option value='Suggestion utilisateur'>Suggestion</option>
                        <option value='Demande spécifique'>Autre</option>
                    </select>
                </div>

                <div className="inp_form">
                    <label>Message</label>
                    <textarea
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                        placeholder="Décrivez votre demande..." /
                    >
                </div>

                <div className="inp_form">
                    <label>Ajouter une image</label>
                    <input
                        type="file"
                        onChange={(e) => setForm({ ...form, image: e.target.files[0] })}
                    />
                </div>

                <button className="btn_submit">
                    Envoyer
                </button>

            </form>
        </div>
    );
}

export default Reclam;